// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'clipboard';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M11.813 3.375h2.812A1.125 1.125 0 0 1 15.75 4.5v11.813a1.125 1.125 0 0 1-1.125 1.125H3.375a1.125 1.125 0 0 1-1.125-1.125V4.5a1.125 1.125 0 0 1 1.125-1.125h2.813a2.813 2.813 0 0 1 5.625 0z' />
    <path d='M9 3.383a.281.281 0 0 1 0-.562m0 .562a.281.281 0 0 0 0-.562' />
  </g>
);

export const viewBox = '0 0 18 18';
